import React from "react";
import { Button } from "@/components/ui/button";
import { LayoutGrid, List, Columns3, Kanban } from "lucide-react";

interface ViewModeToggleProps {
  viewMode: "table" | "grouped" | "cards" | "board";
  onViewModeChange: (mode: "table" | "grouped" | "cards" | "board") => void;
}

export function ViewModeToggle({ viewMode, onViewModeChange }: ViewModeToggleProps) {
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium text-muted-foreground px-3">View Mode</div>
      <div className="grid grid-cols-2 gap-2 px-3">
        <Button
          variant={viewMode === "table" ? "default" : "outline"}
          size="sm"
          className="gap-2"
          onClick={() => onViewModeChange("table")}
        >
          <Columns3 size={16} />
          Table
        </Button>
        <Button
          variant={viewMode === "grouped" ? "default" : "outline"}
          size="sm"
          className="gap-2"
          onClick={() => onViewModeChange("grouped")}
        >
          <List size={16} />
          List
        </Button>
        <Button
          variant={viewMode === "cards" ? "default" : "outline"}
          size="sm"
          className="gap-2"
          onClick={() => onViewModeChange("cards")}
        >
          <LayoutGrid size={16} />
          Cards
        </Button>
        <Button
          variant={viewMode === "board" ? "default" : "outline"}
          size="sm"
          className="gap-2"
          onClick={() => onViewModeChange("board")}
        >
          <Kanban size={16} />
          Board
        </Button>
      </div>
    </div>
  );
}
